import clsx from 'clsx'
import Image from 'next/image'

/* blocks */
import Link from '@/atoms/Link/Link'

/* assets */
import { ReactComponent as CubeScanIcon } from 'public/assets/icons/blog/cube-scan.svg'

function PepperCMLCta() {
  return (
    <section className="container py-5 md:py-9">
      <div className="flex items-center gap-2 | font-heading uppercase text-sm lg:text-xl text-blue-web-50 font-semibold | mb-4">
        <CubeScanIcon />
        Pepper Content Platform
      </div>
      <div
        className={clsx(
          'grid grid-cols-1 lg:grid-cols-12 | items-center | font-heading text-3xl lg:text-4xl text-white bg-blue-web-90 font-medium | rounded-2xl | px-4 py-6 lg:px-14 lg:py-12'
        )}
      >
        <div className="lg:col-span-6 order-2 lg:order-1">
          <h2
            className={clsx(
              'text-3xl md:text-5xl font-medium tracking-tight | mx-auto mb-10 max-w-col-8'
            )}
          >
            <span className="text-green-40">Drive organic growth </span>
            with a full suite of SEO and content tools.
          </h2>
          <div className="font-body font-medium flex flex-col sm:flex-row | gap-4">
            <Link
              href="/book-a-demo/?utm_source=blogs&utm_medium=banner&utm_campaign=blogpages"
              target="_blank"
              className="new-btn-primary"
            >
              Book a demo
            </Link>
            <Link
              href="https://business.peppercontent.io/login?utm_source=blogs&utm_medium=banner&utm_campaign=blogpagessft"
              target="_blank"
              className="new-btn-secondary"
            >
              Start a free trial
            </Link>
          </div>
        </div>
        <div className="lg:col-span-6 order-1 lg:order-2">
          <Image
            src="/assets/blog/pepper_cmp_cta.png"
            alt=""
            width={559}
            height={315}
          />
        </div>
      </div>
    </section>
  )
}

export default PepperCMLCta
